import { render, staticRenderFns } from "./UsersComp.vue?vue&type=template&id=520e3dd7&"
import script from "./UsersComp.vue?vue&type=script&lang=js&"
export * from "./UsersComp.vue?vue&type=script&lang=js&"
import style0 from "./UsersComp.vue?vue&type=style&index=0&id=520e3dd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports